export default {
  title: 'Configura adempimenti pacchetto',
  form: {
    title: 'Crea adempimento',
    companies: {
      label: 'Aziende',
    },
  },
  table: {
    title: 'Cronologia adempimenti',
    fields: {
      name: 'Azienda',
      fulfilled: 'Completato il',
    },
  },
  buttons: {
    create_fulfillment: 'Crea adempimento',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
    failed_to_create_fulfillment: "Creazione dell'adempimento non riuscita",
  },
};
